import * as TYPES from '../types';
import { SUBSCRIBER, COMMON, REDUX_CONSTANT } from '../../constants';

const initialState = {
    lsacFilterData: [
        { name: 'All', type: 'item' },
        { name: 'Prep', type: 'item' },
        { name: 'LawHub Advantage', type: 'item' }
    ],
    prepFilterData: [
        { name: 'All', type: 'item' },
        { name: 'Pending', type: 'item' },
        { name: 'Redeemed', type: 'item' },
        { name: 'Not Redeemed', type: 'item' },
        { name: 'Vendor Refunded', type: 'item' },
        { name: 'N/A', type: 'item' }
    ],
    linkStatusFilterData: [
        { name: 'All', type: 'item' },
        { name: 'Linked', type: 'item' },
        { name: 'Not Linked', type: 'item' }
    ],
    testFilterData: [
        { name: 'All Prep Test', type: 'item' },
        { name: 'Completed Prep Test', type: 'item' },
        { name: 'In Progress Prep Test', type: 'item' }
    ],
    StudentDetails3DotsItems: [
        {
            type: 'item',
            name: SUBSCRIBER.dropdown.changeEmail
        },
        {
            type: 'item',
            name: SUBSCRIBER.updateStudent
        },
        {
            type: 'item',
            name: COMMON.resendInvite
        }
    ],
    isLoading: false,
    showAddSubscriberByDefault: false,
    showResendInviteByDefault: false,
    addStudentConfirmationModalOpen: false,
    firstNameFieldSearchForAdmin: '',
    lastNameFieldSearchForAdmin: '',
    userIdFieldSearchForAdmin: '',
    emailAddressFieldSearchForAdmin: '',
    vendorRoles: undefined,
    allVendorsError: false
};

let lsacFilterValue = '',
    searchValue = '',
    prepFilterValue = '',
    checkCount = 0;

export default function getStudentData(state = initialState, action) {
    checkCount = 0;
    state.bulkUploadData = undefined;
    state.bulkUploadPocessedFile = undefined;
    switch (action.type) {
        case REDUX_CONSTANT.GET_SUBSCRIBER_DATA:
            let studentData =
                action.payload &&
                action.payload.items &&
                action.payload.items.length !== 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                subscriberData: studentData,
                subscriberList: studentData,
                vendorName:
                    action.payload && action.payload.vendorName
                        ? action.payload.vendorName
                        : state.vendorName
                          ? state.vendorName
                          : '',
                redemptionStatus: action.payload.redemptionStatus,
                subscriptionType: action.payload.subscriptionType,
                linkStatus: action.payload.linkStatus,
                pageNumber: action.payload.pageNumber,
                pageSize: action.payload.pageSize,
                recordCount: action.payload.recordCount,
                searchText: action.payload.searchText
                    ? action.payload.searchText
                    : '',
                sortFieldForVendor: action.payload.sortField,
                sortOrderForVendor: action.payload.sortOrder,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_SUBSCRIBER_DATA:
            let adminStudentData =
                action.payload &&
                action.payload.items &&
                action.payload.items.length !== 0
                    ? action.payload.items
                    : [];
            return {
                ...state,
                subscriberData: adminStudentData,
                subscriberList: adminStudentData,
                pageNumber: action.payload.pageNumber,
                pageSize: action.payload.pageSize,
                recordCount: action.payload.recordCount,
                sortOrderForAdmin: action.payload.sortOrder,
                firstNameFieldSearchForAdmin: action.payload.firstName
                    ? action.payload.firstName
                    : '',
                lastNameFieldSearchForAdmin: action.payload.lastName
                    ? action.payload.lastName
                    : '',
                userIdFieldSearchForAdmin: action.payload.userId
                    ? action.payload.userId
                    : '',
                emailAddressFieldSearchForAdmin: action.payload.emailAddress
                    ? action.payload.emailAddress
                    : '',
                isLoading: false
            };
        case REDUX_CONSTANT.ADD_SUBSCRIBER_DATA:
            return {
                ...state,
                addSubscriberData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.FILTER_SUBSCRIBER_DATA_FOR_LSAC:
            return {
                ...state,
                subscriberData: getFilteredSubscriberListForLsac(
                    action.payload,
                    state.subscriberList,
                    state
                ),
                isLoading: false
            };
        case REDUX_CONSTANT.FILTER_SUBSCRIBER_DATA_FOR_PREP:
            return {
                ...state,
                subscriberData: getFilteredSubscriberListForPrep(
                    action.payload,
                    state.subscriberList,
                    state
                ),
                isLoading: false
            };
        case REDUX_CONSTANT.SEARCH_SUBSCRIBER_DATA:
            return {
                ...state,
                subscriberData: getSubscriberListForSearchKey(
                    action.payload,
                    state.subscriberList,
                    state
                ),
                isLoading: false
            };
        case REDUX_CONSTANT.RESEND_INVITATION_DATA:
            return {
                ...state,
                resendInvitationData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.UPDATE_SUBSCRIBER_DATA:
            updateStudentListWithNewStudentData(
                state.subscriberData,
                action.payload
            );
            return {
                ...state,
                updatedSubscriberData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.UPDATE_ADD_SUBSCRIBER_BY_DEFAULT:
            return {
                ...state,
                showAddSubscriberByDefault: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.UPDATE_RESEND_INVITE_BY_DEFAULT:
            return {
                ...state,
                showResendInviteByDefault: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.UPDATE_ADD_STUDENT_CONFIRMATION_BY_DEFAULT:
            return {
                ...state,
                addStudentConfirmationModalOpen: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ALL_VENDORS_DATA:
            return {
                ...state,
                vendorRoles: appendAdminToVendorRoles(action.payload),
                isLoading: false,
                allVendorsError: false
            };
        case REDUX_CONSTANT.REMOVE_ALL_VENDORS_DATA:
            return {
                ...state,
                vendorRoles: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.REFUND_STUDENT_DATA:
            return {
                ...state,
                studentDetails: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.RENEW_STUDENT_DATA:
            return {
                ...state,
                renewSubscriberData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.SET_SELECTED_STUDENT_ITEM:
            return {
                ...state,
                selectedStudent: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_STUDENT_DETAILS:
            return {
                ...state,
                selectedStudent: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_STUDENT_ORDER_DETAILS:
            return {
                ...state,
                studentOrderList: action.payload.items,
                studentOrderListRecordCount: action.payload.recordCount,
                productFilterValue: action.payload.productId,
                studentOrderUserId: action.payload.userId,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_MORE_ADMIN_STUDENT_ORDER_DETAILS:
            return {
                ...state,
                isLoading: false,
                studentOrderList:
                    state.studentOrderList && state.studentOrderList.length > 0
                        ? state.studentOrderList.concat(action.payload.items)
                        : action.payload.items,
                studentOrderListRecordCount: action.payload.recordCount
            };
        case REDUX_CONSTANT.GET_STUDENT_VENDOR_ORDER:
            return {
                ...state,
                vendorOrderList: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_DETAIL_RESET:
            return {
                ...state,
                studentOrderList: undefined,
                isLoading: false
            };
        case REDUX_CONSTANT.GET_ADMIN_STUDENT_TEST_HISTORY_MORE:
            return {
                ...state,
                isLoading: false,
                allStudentTestHistory:
                    state.allStudentTestHistory &&
                    state.allStudentTestHistory.length > 0
                        ? state.allStudentTestHistory.concat(
                              action.payload.items
                          )
                        : action.payload.items,
                totalAllTestHistoryRecords: action.payload.recordCount
            };

        case REDUX_CONSTANT.GET_ADMIN_STUDENT_TEST_HISTORY_NEW:
            return {
                ...state,
                isLoading: false,
                allStudentTestHistory: action.payload.items,
                totalAllTestHistoryRecords: action.payload.recordCount
            };
        case REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_MORE:
            return {
                ...state,
                isLoading: false,
                studentTestHistory:
                    state.studentTestHistory &&
                    state.studentTestHistory.length > 0
                        ? state.studentTestHistory.concat(action.payload.items)
                        : action.payload.items,
                totalTestHistoryRecords: action.payload.recordCount,
                testHistorySelectedFilterValue: action.payload.isComplete
            };
        case REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_NEW:
            return {
                ...state,
                isLoading: false,
                studentTestHistory: action.payload.items,
                totalTestHistoryRecords: action.payload.recordCount,
                testHistorySelectedFilterValue: action.payload.isComplete
            };
        case REDUX_CONSTANT.TEST_RESULT_PROCESSED:
            return {
                ...state,
                isLoading: false,
                testResult: action.payload
            };
        case REDUX_CONSTANT.ADMIN_TEST_RESULT_PROCESSED:
            return {
                ...state,
                isLoading: false,
                adminTestResult: action.payload
            };

        case REDUX_CONSTANT.ADMIN_TEST_RESULT_PDF:
            return {
                ...state,
                isLoading: false,
                adminTestResultPDF: action.payload
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_HOLD_DATA:
            return {
                ...state,
                isLoading: false,
                adminStudentOrderHoldValue: action.payload
            };

        case REDUX_CONSTANT.ADMIN_STUDENT_ORDER_OFF_HOLD_DATA:
            return {
                ...state,
                isLoading: false,
                adminStudentOrderOffHoldValue: action.payload
            };

        case REDUX_CONSTANT.STUDENT_DETAIL_RESET:
            return {
                ...state,
                isLoading: false,
                testResult: {},
                studentTestHistory: undefined
            };
        case REDUX_CONSTANT.TEST_RESULT_PDF:
            return {
                ...state,
                isLoading: false,
                testResultPDF: action.payload
            };
        case REDUX_CONSTANT.BULK_UPLOAD_STUDENT_DATA:
            return {
                ...state,
                bulkUploadData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.BULK_UPLOAD_STUDENT_FAIL:
            return {
                ...state,
                bulkUploadFailed: action.error,
                isLoading: false
            };
        case REDUX_CONSTANT.BULK_UPLOAD_STATUS:
            return {
                ...state,
                bulkUploadedStatus: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.BULK_UPLOAD_PROCESSED:
            return {
                ...state,
                bulkUploadPocessedFile: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.SET_RESEND_INVITE_FLAG:
            return {
                ...state,
                resendInviteFlag: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.UPGRADE_STUDENT_SUBSCRIPTION_DATA:
            return {
                ...state,
                upgradeStudentSubscriptionData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.SUBSCRIBER_HOME_PAGE_RESET:
            return {
                ...state,
                recordCount: 0,
                pageNumber: 1,
                subscriberData: [],
                subscriberList: [],
                isLoading: false
            };
        case REDUX_CONSTANT.ADMIN_STUDENT_DETAIL_RESET:
            return {
                ...state,
                studentOrderList: undefined,
                userProducts: [],
                allStudentTestHistory: [],
                totalAllTestHistoryRecords: 0,
                adminTestResult: [],
                isLoading: false
            };

        case REDUX_CONSTANT.GET_VENDOR_REFUND_DATA:
            return {
                ...state,
                vendorOrderRefund: action.payload,
                isLoading: false
            };

        case REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA:
            return {
                ...state,
                refundVendorProduct: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.ADMIN_STUDENT_SEARCH_RESET:
            return {
                ...state,
                firstNameFieldSearchForAdmin: '',
                lastNameFieldSearchForAdmin: '',
                userIdFieldSearchForAdmin: '',
                emailAddressFieldSearchForAdmin: '',
                recordCount: 0,
                pageNumber: 1,
                subscriberData: [],
                subscriberList: [],
                isLoading: false
            };
        case REDUX_CONSTANT.GET_REFRESH_SUBSCRIPTION_DATA:
            return {
                ...state,
                refreshSubscriptionData: action.payload,
                isLoading: false
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                subscriberData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_ADMIN_SUBSCRIBER_DATA
                        ? []
                        : state.subscriberData,
                addSubscriberData:
                    action.payload.title == REDUX_CONSTANT.ADD_SUBSCRIBER_DATA
                        ? action.payload.msg
                        : state.addSubscriberData,
                renewSubscriberData:
                    action.payload.title == REDUX_CONSTANT.RENEW_STUDENT_DATA
                        ? action.payload.msg
                        : state.renewSubscriberData,
                updatedSubscriberData:
                    action.payload.title ==
                    REDUX_CONSTANT.UPDATE_SUBSCRIBER_DATA
                        ? action.payload.msg
                        : state.updatedSubscriberData,
                studentTestHistory:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_STUDENT_TEST_HISTORY_NEW
                        ? action.payload.msg
                        : state.studentTestHistory,
                subscriberData:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? []
                        : state.subscriberData,
                recordCount:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? 0
                        : state.recordCount,
                pageNumber:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? 1
                        : state.pageNumber,
                redemptionStatus:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.redemptionStatus,
                subscriptionType:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.subscriptionType,
                linkStatus:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? ''
                        : state.linkStatus,
                subscriberList:
                    action.payload.title == REDUX_CONSTANT.GET_SUBSCRIBER_DATA
                        ? []
                        : state.subscriberList,
                selectedStudent:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_ADMIN_STUDENT_DETAILS
                        ? undefined
                        : state.selectedStudent,
                adminStudentOrderHoldValue:
                    action.payload.title ===
                    REDUX_CONSTANT.ADMIN_STUDENT_ORDER_HOLD_DATA
                        ? action.payload.msg
                        : state.adminStudentOrderHoldValue,
                adminStudentOrderOffHoldValue:
                    action.payload.title ===
                    REDUX_CONSTANT.ADMIN_STUDENT_ORDER_OFF_HOLD_DATA
                        ? action.payload.msg
                        : state.adminStudentOrderOffHoldValue,
                vendorOrderRefund:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_REFUND_DATA
                        ? action.payload.msg
                        : state.vendorOrderRefund,
                refundVendorProduct:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_VENDOR_REFUND_PRODUCT_DATA
                        ? action.payload.msg
                        : state.refundVendorProduct,
                refreshSubscriptionData:
                    action.payload.title ===
                    REDUX_CONSTANT.GET_REFRESH_SUBSCRIPTION_DATA
                        ? action.payload.msg
                        : state.refreshSubscriptionData,
                resendInvitationData:
                    action.payload.title ===
                    REDUX_CONSTANT.RESEND_INVITATION_DATA
                        ? action.payload.msg
                        : state.resendInvitationData,
                vendorOrderList:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_STUDENT_VENDOR_ORDER
                        ? []
                        : state.vendorOrderList,
                allVendorsError:
                    action.payload.title === REDUX_CONSTANT.GET_ALL_VENDORS_DATA
                        ? true
                        : state.allVendorsError
            };
        case REDUX_CONSTANT.ISLOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        default:
            return state;
    }
}

function appendAdminToVendorRoles(roles) {
    roles.unshift({ vendorId: 'ADMIN', vendorName: 'All' });
    return roles;
}

function updateStudentListWithNewStudentData(studentData, newStudentData) {
    if (!Array.isArray(studentData) || !newStudentData) return;
    let studentIndex = studentData.findIndex(
        (student) =>
            student.studentCoachingId == newStudentData.studentCoachingId
    );
    if (studentIndex > -1) {
        studentData[studentIndex] = newStudentData;
    }
}

function getFilteredSubscriberListForLsac(value = '', data, state) {
    lsacFilterValue = value;
    let dataSet = data;
    if (value.length > 0 && value !== 'All') {
        dataSet = data.filter((item) => item.subscriptionType === value);
    }

    if (checkCount < 2) {
        checkCount++;
        return getFilteredSubscriberListForPrep(
            prepFilterValue,
            dataSet,
            state
        );
    } else {
        checkCount = 0;
        return dataSet;
    }
}

function getFilteredSubscriberListForPrep(value = '', data, state) {
    prepFilterValue = value;
    let dataSet = data;
    if (value.length > 0 && value !== 'All') {
        dataSet = data.filter((item) => {
            if (value === 'Redeemed') {
                return item.wasPrepPlusRedeemed === true;
            } else if (value === 'Pending') {
                return (
                    item.wasPrepPlusRedeemed === false &&
                    (!item.isPrepPlusIncludedFromVendor || !item.linked)
                );
            } else if (value === 'Not Redeemed') {
                return (
                    item.wasPrepPlusRedeemed === undefined ||
                    (item.wasPrepPlusRedeemed === false &&
                        item.isPrepPlusIncludedFromVendor &&
                        item.linked)
                );
            }
            return false;
        });
    }

    if (checkCount < 2) {
        checkCount++;
        return getSubscriberListForSearchKey(searchValue, dataSet, state);
    } else {
        checkCount = 0;
        return dataSet;
    }
}

function getSubscriberListForSearchKey(value = '', data, state) {
    searchValue = value;
    let dataSet = data;
    dataSet = data.filter((item) =>
        item.name.toLowerCase().includes(value.toLowerCase())
    );
    if (checkCount < 2) {
        checkCount++;
        return getFilteredSubscriberListForLsac(
            lsacFilterValue,
            dataSet,
            state
        );
    } else {
        checkCount = 0;
        return dataSet;
    }
}
